import clsx from "clsx";

export function DescriptionList({
	className,
	...props
}: React.ComponentPropsWithoutRef<"dl">) {
	return (
		<dl
			{...props}
			className={clsx(
				className,
				"grid grid-cols-1 text-base/6 sm:grid-cols-[min(50%,--spacing(80))_auto] sm:text-sm/6",
			)}
		/>
	);
}

export function DescriptionTerm({
	className,
	...props
}: React.ComponentPropsWithoutRef<"dt">) {
	return (
		<dt
			{...props}
			className={clsx(
				className,
				"col-start-1 border-t border-base-content/5 pt-3 text-base-content/50 first:border-none sm:border-t sm:border-base-content/5 sm:py-3 sm:dark:border-base-content/5",
			)}
		/>
	);
}

export function DescriptionDetails({
	className,
	...props
}: React.ComponentPropsWithoutRef<"dd">) {
	return (
		<dd
			{...props}
			className={clsx(
				className,
				"pt-1 pb-3 text-base-content sm:border-t sm:border-base-content/5 sm:py-3 sm:nth-2:border-none dark:sm:border-base-content/5",
			)}
		/>
	);
}
